// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import HighchartsVue from 'highcharts-vue';
import flagIcon from 'vue-flag-icon';
// import fullCalendar from 'vue-full-calendar';
import '@/lib/data/setup';
import '@/lib/util/overrides';
import '@/lib/util/moment-timezone';
import '@/components/directives';
import extendedSelect from '@/components/elementui-select';
import vuesignature from 'vue-signature';
import axios from 'axios';
import VueTelInput from 'vue-tel-input';
import VueScrollTo from 'vue-scrollto';
import Cookies from 'js-cookie';

// translation
// https://element.eleme.io/#/en-US/component/i18n
import VueI18n from 'vue-i18n';
import locale from 'element-ui/lib/locale/lang/en';
import localeTr from 'element-ui/lib/locale/lang/tr-TR';
import localeRo from 'element-ui/lib/locale/lang/ro';
import localeFr from 'element-ui/lib/locale/lang/fr';
import localeEs from 'element-ui/lib/locale/lang/es';
import localeDe from 'element-ui/lib/locale/lang/de';
import localePt from 'element-ui/lib/locale/lang/pt';
import localeAr from 'element-ui/lib/locale/lang/ar';
import localeEl from 'element-ui/lib/locale/lang/el';

import * as VueGoogleMaps from 'vue2-google-maps';
import * as firebase from 'firebase/app';
import moment from 'moment';
import formSection from '@app/src/main/components/inspection/section.vue';
import { GOOGLE_API_KEY } from '@app/common/utils/constants';
import tableheader from '@/lib/util/tableheader';
import resize from '@/lib/util/resize';
import router from './router';
import 'firebase/analytics';
import 'firebase/auth';

import App from './App.vue';
import store from '../store/store';

import 'font-awesome/scss/font-awesome.scss';
import 'element-ui/lib/theme-chalk/index.css';
// import 'fullcalendar/dist/fullcalendar.min.css';
import '@/styles/util.scss';
import '@/styles/color.scss';
import '@/styles/theme.scss';
import '@/styles/responsive.scss';
import 'bulma/css/bulma.min.css';

import '@/../assets/fonts/css/icons.css';

// import ECharts from '@/components/echartsv5' // refers to components/ECharts.vue in webpack
// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';

// register component to use
// Vue.component('v-chart', ECharts)

Vue.component('formSection', formSection);

Vue.prototype.$firebase = firebase.initializeApp({
    apiKey: 'AIzaSyAQR43hRtutmY1YRTB3wt5xxiV1JPMuk9k',
    authDomain: 'virtualriskspace.firebaseapp.com',
    databaseURL: 'https://virtualriskspace.firebaseio.com',
    projectId: 'virtualriskspace',
    storageBucket: 'virtualriskspace.appspot.com',
    messagingSenderId: '1088752406703',
    appId: '1:1088752406703:web:2f2947928a46906193045a',
    measurementId: 'G-KJJFSST8DC',
});

Vue.prototype.moment = moment;

firebase.analytics();

Vue.use(VueI18n);
Vue.use(HighchartsVue);
Vue.use(resize);
Vue.use(tableheader);
Vue.use(flagIcon);
// Vue.use(fullCalendar);
Vue.use(vuesignature);
Vue.use(VueTelInput);
Vue.use(VueScrollTo);

const dir = Cookies.get('dir') ? Cookies.get('dir') : 'ltr';
const urlParams = new URLSearchParams(window.location.href.split('?')[1]);
const paramsLanguage = urlParams.get('l');
const storedLanguage = window.localStorage.language_code;
const browserLanguage = (window.navigator.userLanguage || window.navigator.language).split('-')[0];
const originalLanguage = paramsLanguage || storedLanguage || browserLanguage || 'en';
const language = /tr|ro|en|fr|es|de|pt|ar|el|en_US/g.test(originalLanguage)
    ? originalLanguage
    : 'en';

Vue.use(VueGoogleMaps, {
    load: {
        key: GOOGLE_API_KEY,
        libraries: 'places',
        language,
    },
});

if (language === 'ar') {
    Cookies.set('dir', 'rtl', { secure: true });

    if (dir !== 'rtl') {
        window.location.reload();
    }
} else {
    Cookies.set('dir', 'ltr', { secure: true });

    if (dir !== 'ltr') {
        window.location.reload();
    }
}

window.localStorage.language_code = language;
Vue.config.lang = language;

let localeCmp;

switch (language) {
    case 'tr':
        localeCmp = localeTr;
        break;
    case 'ro':
        localeCmp = localeRo;
        break;
    case 'fr':
        localeCmp = localeFr;
        break;
    case 'es':
        localeCmp = localeEs;
        break;
    case 'de':
        localeCmp = localeDe;
        break;
    case 'pt':
        localeCmp = localePt;
        break;
    case 'ar':
        localeCmp = localeAr;
        break;
    case 'el':
        localeCmp = localeEl;
        break;
    case 'en_US':
        localeCmp = locale;
        break;
    default:
        localeCmp = locale;
}

ElementUI.locale(localeCmp);
Vue.use(ElementUI);

/**
 * Extensions
 * Element ui select extensions for mobile safari browsers
 */
extendedSelect.extend();

axios.get(`/translation/all?language_code=${language}&r=${Math.random()}`).then((result) => {
    Cookies.set('lang', language, { secure: true });
    const response = result.data;
    response.data = response.data ? response.data : {};
    response.data.fallbackLocale = 'en';
    response.data.formatFallbackMessages = true;
    const i18n = new VueI18n(response.data || {});

    window.app = new Vue({
        el: '#app',
        router,
        store,
        i18n,
        components: { App },
        template: '<App/>',
    });
});
/* eslint-disable no-new */
